import { api } from './api.js';

export const listAPIKeys  = () => api.get('/api/me/api-keys');
export const createAPIKey = (name) => api.post('/api/me/api-keys', { name });
export const revokeAPIKey = (id) => api.post(`/api/me/api-keys/${id}/revoke`);
export const deleteAPIKey = (id) => api.delete(`/api/me/api-keys/${id}`);
